import { request } from '@/utils/api-request'


export function getDocentHistoryList(params) {
  const url = "/admin/ssdocent/list";
  const config = {
    method: "post",
    url,
    data: params,
  };
  return request(config, true);
}

export function getDocentHistoryDetail(params) {
  const url = "/admin/ssdocent/detail";
  const config = {
    method: "post",
    url,
    data: params,
  };
  return request(config, true);
}

export function updateDocentHistory(params) {
  const url = "/admin/ssdocent/update";
  const config = {
    method: "post",
    url,
    data: params,
  };
  return request(config, true);
}

